'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');

const tableFoot = "_table-foot_1abiq_1";
const styles = {
	tableFoot: tableFoot
};

const TableFoot = (props) => {
  return jsxRuntime.jsx("tfoot", { className: styles.tableFoot, "data-zds": true, children: props.children });
};

exports.TableFoot = TableFoot;
//# sourceMappingURL=TableFoot.cjs.js.map
